/* Keep customer on the same page when removing from Kalles mini cart */
(function(){"use strict";
if(window.__ttNoRedirectRemove)return;window.__ttNoRedirectRemove=true;
var removing=false;
function root(){return window.Shopify&&Shopify.routes&&Shopify.routes.root||"/"}
async function refresh(){
 var q=new URLSearchParams(location.search).get("preview_theme_id");
 var u=root()+"cart?section_id=mini_cart"+(q?"&preview_theme_id="+encodeURIComponent(q):"");
 var r=await fetch(u,{credentials:"same-origin",cache:"no-store"});if(!r.ok)throw Error("Could not refresh cart");
 var doc=new DOMParser().parseFromString(await r.text(),"text/html");
 var drawer=document.querySelector("#t4s-mini_cart");if(!drawer)return;
 ["[data-cart-items]","[data-cart-prices]","[data-cart-discounts]"].forEach(function(sel){
  var a=drawer.querySelector(sel),b=doc.querySelector(sel);if(a&&b)a.replaceWith(b.cloneNode(true));
 });
 var next=doc.querySelector("[data-ccount]");if(next)drawer.dataset.ccount=next.dataset.ccount;
}
document.addEventListener("click",async function(e){
 var button=e.target.closest&&e.target.closest("#t4s-mini_cart [data-cart-remove]");
 if(!button)return;
 e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();
 if(removing)return;
 var id=button.getAttribute("data-id");if(!id)return;
 removing=true;button.setAttribute("aria-disabled","true");
 try{
  var r=await fetch(root()+"cart/change.js",{method:"POST",credentials:"same-origin",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({id:id,quantity:0})});
  var cart=await r.json();if(!r.ok)throw Error(cart.description||"Unable to remove item");
  await refresh();
  document.documentElement.classList.toggle("t4s-cart-count-0",cart.item_count===0);
  document.querySelector("#t4s-mini_cart")?.setAttribute("data-ccount",String(cart.item_count));
  document.querySelectorAll("[data-cart-count],.t4s-cart-count").forEach(function(x){if(!x.children.length)x.textContent=cart.item_count});
  document.dispatchEvent(new CustomEvent("cart:changed",{bubbles:true}));
 }catch(err){button.title=err.message||"Unable to remove";button.removeAttribute("aria-disabled");}
 finally{removing=false}
},true);
})();
